import { useState } from 'react';

const useDeleteModel = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const API_URL = process.env.REACT_APP_DELETE_MODEL_API || '';

  const deleteModel = async (modelName: string): Promise<boolean> => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ model_name: modelName }),
      });
      if (!response.ok) {
        const text = await response.text();
        setError(text || `Request failed with status ${response.status}`);
        return false;
      }
      return true;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to delete model';
      setError(message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { deleteModel, loading, error };
};

export default useDeleteModel;
